import React, { Component } from "react";
import "./productsFiles.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import { Link, useParams } from "react-router-dom";

import { getProductFilesById } from "../../constants/products-Files";


function ProductsFiles() {
    const params = useParams();
    const productFile = [...getProductFilesById(params.id)][0];

    return (
        <Page>
            <Header />
            <h1 className="text-title-body">فایل های کمپرسور</h1>
            <div className="modelheadbox">
                <h1 >{productFile.title}</h1>
                <hr className="divider" />
            </div>
            {productFile.isHasUseAndMaintenance === "true" && (
                <section className="container ">
                    <div className="modelheadbox">
                        <div className="row hrow mt-4">
                            <a className="btn btn-dark" target="_blank" href={`${productFile.useAndMaintenanceUrl}`} download>دریافت فایل دستورالعمل استفاده و نگهداری</a>
                        </div>
                    </div>
                </section>
            )}
            {productFile.isHasInstallationAndRequirements === "true" && (
                <section className="container ">
                    <div className="modelheadbox">
                        <div className="row hrow mt-4">
                            <a className="btn btn-dark" target="_blank" href={`${productFile.installationAndRequirementsUrl}`} download>دریافت فایل دستورالعمل شرایط و الزامات نصب کمپرسورهای ثابت</a>
                        </div>
                    </div>
                </section>
            )}
            {productFile.isHasWarrantyPolicy === "true" && (
                <section className="container ">
                    <div className="modelheadbox">
                        <div className="row hrow mt-4">
                            <a className="btn btn-dark" target="_blank" href={`${productFile.warrantyPolicyUrl}`} download>دریافت فایل نظامنامه گارانتی هوایار</a>
                        </div>
                    </div>
                </section>
            )}
            <Footer />
        </Page>
    );
}
export default ProductsFiles;